import { useState } from "react";

const DRAFT_STATUS = "טיוטא פרומדי";

// Smart status suggestion for a manual release.
export const getSuggestedStatus = (order) => {
  // Order-level rule: an obligo exception on the order always forces a draft
  // status, regardless of any other line-level condition.
  if (order.NEO_OBLIGOEXIST === "Y") return DRAFT_STATUS;
  const items = order?.ORDERITEMS_SUBFORM || [];
  if (items.some((i) => i.PDES?.includes("SIMILAC"))) return "נדרש פיצול";
  return "מאושר פרומדי";
};

// Status selection + release of one order. onReleased runs after a successful update.
const useOrderRelease = ({ order, releaseStatuses, onUpdateStatus, onReleased }) => {
  const suggestedStatus = getSuggestedStatus(order);
  // Obligo exception forces the draft status — Priority rejects any other
  // status in that case, so don't even offer them.
  const availableStatuses = order.NEO_OBLIGOEXIST === "Y" ? [DRAFT_STATUS] : releaseStatuses;
  // Only pre-select the suggestion if this user may use it (e.g. external
  // suppliers can't select the "requires split" status).
  const [selectedStatus, setSelectedStatus] = useState(
    availableStatuses.includes(suggestedStatus) ? suggestedStatus : "",
  );
  const [updating, setUpdating] = useState(false);
  const [updateError, setUpdateError] = useState(null);

  const release = async () => {
    if (!selectedStatus) return;
    setUpdating(true);
    setUpdateError(null);
    try {
      await onUpdateStatus(order.ORDNAME, selectedStatus);
      setSelectedStatus("");
      onReleased();
    } catch (err) {
      setUpdateError(err?.msg || "שגיאה בעדכון סטטוס ההזמנה");
    } finally {
      setUpdating(false);
    }
  };

  return { suggestedStatus, availableStatuses, selectedStatus, setSelectedStatus, updating, updateError, release };
};

export default useOrderRelease;
